import React from "react";
import keys from "lodash/keys";
import map from "lodash/map";
import { connect } from "~/redux/connect";
import { Box, Button, Pressable, Popover, VStack } from "~/native-ui";
import { getFitleredViewState } from "~/StateGetters/FilteredViewStateGetters";
import TableRecordsCountAndTitle from "./TableRecordsCountAndTitle";


import get from "lodash/get";
import orderBy from "lodash/orderBy";
import { FilteredViewRow } from "./FilteredViewRow";
import { settingsActionCreator } from "~/actions/settingsActions";
import { Divider } from "~/native-ui";

const mapStateToProps = (state, { modelId }) => {
    return {
        ...getFitleredViewState(state, modelId).getFilteredViewProps(),
    }
}

const mapDispatchToProps = (dispatch, {modelId}) => {
    const settingActions = settingsActionCreator(modelId);
    return {
        duplicateView: () => dispatch(settingActions.duplicateView()),
    }
}

const mergedProps = ({ sharedViews, defaultViews, views, ...stateProps }, dispatch, ownProps) => {
    const orderedKeys = (views) => orderBy(keys(views), (key) => get(views, `${key}.createdAt`), "asc")
    
    return {
        ...stateProps, ...dispatch, ...ownProps,
        views: orderedKeys(defaultViews).concat(orderedKeys(sharedViews)).concat(orderedKeys(views)),
    }
}

const FilteredViews = (props) => {
    const { views, modelId, modelName } = props;
    const { duplicateView, trans, } = props;
    const [ showPopover, shouldShowPopover ] = React.useState(false);

    const renderTrigger = React.useCallback(({ref, ...props}) => (
        <Pressable { ...props } ref={ref}>
            <TableRecordsCountAndTitle modelId={modelId} { ...props } />
        </Pressable>
    ), [ modelId ]),
    
    
    
    handleDuplicateView = React.useCallback(() => {
        duplicateView();
    }, [duplicateView]),



    onOpen = React.useCallback(() => {
        shouldShowPopover(true);
    }, []),



    onClose = React.useCallback(() => {
        shouldShowPopover(false);
    }, []);


    return (
        <Popover
            trapFocus
            shouldFlip
            shadow="2"
            isOpen={showPopover}
            placement="bottom left"
            isKeyboardDismissable
            trigger={renderTrigger}
            onClose={onClose}
            onOpen={onOpen}
        >
            <Popover.Content>
                <Popover.Arrow height={10} width={10} />
                <Popover.Body>
                    <VStack space="1">
                        { map(views, (view) => <FilteredViewRow key={view} view={view} modelId={modelId} onGoToView={onClose} modelName={modelName} />) }
                        <Divider />
                        <Box flex alignItems="flex-start" key="button-row">
                            <Button.ButtonGroup>
                                <Button primary onPress={handleDuplicateView} icon="add">
                                    {trans("views.duplicateCurrentView")}
                                </Button>
                            </Button.ButtonGroup>
                        </Box>
                    </VStack>
                </Popover.Body>
            </Popover.Content>
        </Popover>
    )
}

const FilteredViewsRx = connect(mapStateToProps, mapDispatchToProps, mergedProps)(FilteredViews)

export { FilteredViewsRx as FilteredViews }